export const voNotificationsDefaultConfig = {
  stageUpdates: {
    isTurnedOn: true,
    isNotifyAllRelatedUsers: true,
    locationIds: [],
    userRoles: [],
    userIds: [],
  },
};
